import { render, staticRenderFns } from "./editVideoDialog.vue?vue&type=template&id=68c240fd&scoped=true&"
import script from "./editVideoDialog.vue?vue&type=script&lang=js&"
export * from "./editVideoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c240fd",
  null
  
)

export default component.exports